interface MultiPreviewProps {
  outputs: Record<string, string>;
}

export function MultiPreview({ outputs }: MultiPreviewProps) {
  return (
    <div className="grid grid-cols-4 gap-4 p-4">
      {Object.entries(outputs).map(([key, url]) => (
        <div key={key} className="flex flex-col items-center">
          <img src={url} className="shadow-lg rounded" alt={key} />
          <span className="text-foreground/70 mt-2 capitalize">{key}</span>
        </div>
      ))}
    </div>
  );
}
